import React from "react";

export const pc2MigrationDeadlineBanner = (setNotificationsItems) => {
  return {
    type: "info",
    content: (
      <React.Fragment>
        Effective 10/1, Partners who have not migrated to the Partner Central
        experience in the AWS Console will lose access to all core Partner
        Central functionality, including the ability to submit fund requests,
        manage claims, and create or progress opportunities. No data is lost;
        all functionality (including in-progress workflows) resumes immediately
        upon completing migration for users with the appropriate permissions
        assigned in AWS IAM. There is no impact to Partners who have completed
        migration.
      </React.Fragment>
    ),
    dismissible: true,
    dismissLabel: "Dismiss message",
    onDismiss: () => setNotificationsItems([]),
    id: "pc2_migration_deadline_banner",
  };
};
